<script setup>
import { useBreakpoints } from '@vueuse/core'

defineProps({
  calcHistory: {
    type: Array,
    required: true
  }
})

const breakpoints = useBreakpoints({
  mobile: 320,
  desktop: 768,
})

const activeBreakpoint = breakpoints.active()
</script>

<template>
  <table class="calc-history-table table-desktop" v-if="activeBreakpoint === 'desktop'">
    <thead>
      <tr>
        <th>Conversion Type</th>
        <th>Source Value</th>
        <th>Result</th>
        <th>Unit</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, key) in calcHistory" :key="key">
        <td>{{ item.conversionType === 'a1c_to_eag' ? 'A1C to eAG' : 'eAG to A1C' }}</td>
        <td>{{ item.inputValue }}</td>
        <td>{{ item.calculatedResult }}</td>
        <td>{{ item.targetUnit === 'mg_dl' ? 'mg/dL' : 'mmol/L' }}</td>
      </tr>
    </tbody>
  </table>
  <table v-else class="calc-history-table table-mobile">
    <tbody>
      <tr v-for="(item, key) in calcHistory" :key="key">
        <td>
          <div><strong>Conversion Type</strong> {{ item.conversionType === 'a1c_to_eag' ? 'A1C to eAG' : 'eAG to A1C' }}</div>
          <div><strong>Source Value</strong> {{ item.inputValue }}</div>
          <div><strong>Result</strong> {{ item.calculatedResult }}</div>
          <div><strong>Unit</strong> {{ item.targetUnit === 'mg_dl' ? 'mg/dL' : 'mmol/L' }}</div>
        </td>
      </tr>
    </tbody>
  </table>
</template>
